"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = require("../../components/button/button");
var allMeetingsPageActions_1 = require("./allMeetingsPageActions");
var bases_1 = require("../../bases");
var table_1 = require("../../components/tables/table");
var listOptionSlideContainer_1 = require("../../components/slideContainer/listOptionSlideContainer");
var observationProvider_1 = require("../../utils/observationProvider");
var pageTypes_1 = require("../pageTypes");
var dateField_1 = require("../../components/fields/dateField");
var endpointUrls_1 = require("../../api/endpointUrls");
var listOptionSlideContainerActions_1 = require("../../components/slideContainer/listOptionSlideContainerActions");
var stringUtils_1 = require("../../utils/stringUtils");
var meetingDetailForm_1 = require("../../components/meetinigs/meetingDetailForm");
var stringDropdownField_1 = require("../../components/fields/stringDropdownField");
var checkBoxField_1 = require("../../components/fields/checkBoxField");
var textField_1 = require("../../components/fields/textField");
var meetingStatusField_1 = require("../../components/fields/meetingStatusField");
var numberDropdownField_1 = require("../../components/fields/numberDropdownField");
var businessAreaDropdown_1 = require("../../components/fields/businessAreaDropdown");
var departmentDropdown_1 = require("../../components/fields/departmentDropdown");
var timeField_1 = require("../../components/fields/timeField");
var fieldType_1 = require("../../components/fields/fieldType");
var components_1 = require("../../components");
var utils_1 = require("../../utils");
var meetingDetailFormActions_1 = require("../../components/meetinigs/meetingDetailFormActions");
var AllMeetingsPage = /** @class */ (function (_super) {
    __extends(AllMeetingsPage, _super);
    function AllMeetingsPage(api, navigator, currentUserManager) {
        var _this = _super.call(this, pageTypes_1.default.AllMeetingsList, 'All Meetings List') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.goToEventLanding = function (eventId) { return function () {
            _this.navigator.goToEventLanding(eventId);
        }; };
        _this.loadExapndedContent = function (meeting) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = meeting;
                        return [4 /*yield*/, this.api.get("".concat(endpointUrls_1.default.Events, "/").concat(meeting.eventId, "/MeetingTableItemDetail/").concat(meeting.id))];
                    case 1:
                        _a.expandedContent = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadEventOptions = function () {
            return _this.api.getEventDropdownOptions()
                .then(function (options) {
                var eventOptions = options.map(function (option) {
                    return {
                        label: "".concat(option.name, " (").concat(utils_1.DateUtils.formatDate(option.startDate, utils_1.DateFormats.YYYY), ")"),
                        value: option.id
                    };
                });
                _this.eventSearchField.setNumberOptions(eventOptions);
            });
        };
        _this.loadData = function () {
            return _this.api.getTablePage(endpointUrls_1.default.Meetings + '/AllMeetings', _this._table.recordsPerPage, _this._table.currentPage, _this._table.sortExpression, _this._table.searchPhrase, __assign({}, _this.listOptionSlideContainer.appliedFiltersModel))
                .then(function (response) {
                _this._meetingDetailForm = null;
                return response;
            });
        };
        _this.buildEventLandingButton = function (meeting) {
            return new button_1.default({
                onClick: _this.goToEventLanding(meeting.eventId),
                text: meeting.name
            });
        };
        _this.buildMeetingDetailButton = function (meeting, truncateName) {
            var buttonText;
            if (truncateName) {
                buttonText = stringUtils_1.default.truncate(meeting.name, 25);
            }
            else {
                buttonText = stringUtils_1.default.truncate(meeting.name, 30);
            }
            var btn = new button_1.default({
                onClick: function () {
                    _this._meetingDetailForm = new meetingDetailForm_1.default(_this.api, meeting.eventId, _this.navigator, _this.currentUserManager);
                    _this._meetingDetailForm.observationProvider.observe(function () {
                        _this._meetingDetailForm = null;
                        _this.observationProvider.notifyObservers(allMeetingsPageActions_1.default.MeetingDetailClosed);
                    }, meetingDetailFormActions_1.default.Closed);
                    _this._meetingDetailForm.observationProvider.observeMany(function () {
                        _this.observationProvider.notifyObservers(allMeetingsPageActions_1.default.MeetingDetailFormOpened);
                    }, [meetingDetailFormActions_1.default.Opened, meetingDetailFormActions_1.default.Loaded]);
                    _this._meetingDetailForm.open(meeting.id);
                    _this.observationProvider.notifyObservers(allMeetingsPageActions_1.default.MeetingDetailButtonClicked);
                },
                text: buttonText
            });
            btn.setDisabled(_this.table.isLocked);
            return btn;
        };
        _this.buildMeetingNotesReportUrl = function (meeting) {
            return '/#' + _this.navigator.urlBuilder.buildMeetingNotesReportPage({ meetingId: meeting.id, meetingUniqueId: meeting.uniqueId });
        };
        _this.observationProvider = new observationProvider_1.default();
        _this._table = new table_1.default(_this.loadData, api, true, _this.loadExapndedContent);
        _this._table.searchBoxPlaceholder = 'By customer, company or meeting name';
        var filters = [
            new stringDropdownField_1.default('isActive', 'Is Active', false, [{ label: 'All', value: '' }, { label: 'Active', value: 'true' }, { label: 'Inactive', value: 'false' }]),
            new checkBoxField_1.default('myMeetings', 'My meetings'),
            new checkBoxField_1.default('hasNotes', 'Has Notes'),
            new textField_1.default('meetingNumber', 'Meeting #', false, 5, null, null, fieldType_1.default.Int),
            new textField_1.default('meetingName', 'Meeting Name', false, 100),
            new meetingStatusField_1.default('status', 'Status', false),
            new textField_1.default('customerName', 'Customer Name', false, 100),
            new businessAreaDropdown_1.default(_this.api, 'businessAreaId', 'Business Area', false, null),
            new departmentDropdown_1.default(_this.api, 'departmentId', false),
            new dateField_1.default('startDate', 'Start Date', false),
            new dateField_1.default('endDate', 'End Date', false),
            new timeField_1.default('eventStartTime', 'Start Time', false),
            new timeField_1.default('eventEndTime', 'End Time', false),
        ];
        _this.myNotesSwitchField = new checkBoxField_1.default('myNotesSearch', 'My Notes');
        _this.myNotesSwitchField.observationProvider.observe(function () {
            _this.listOptionSlideContainer.appliedFiltersModel.myNotes = _this.myNotesSwitchField.value;
            _this._table.load();
        }, components_1.FieldActions.ValueChanged);
        _this.eventSearchField = new numberDropdownField_1.default('eventId', 'Event Search', false, [], 'required', null, fieldType_1.default.DropDown, 'All Events');
        _this.eventSearchField.observationProvider.observe(function () {
            _this.listOptionSlideContainer.appliedFiltersModel.eventId = _this.eventSearchField.value;
            _this._table.load();
        }, components_1.FieldActions.ValueChanged);
        var defaultFilters = {
            isActive: true,
            myMeetings: true
        };
        _this.listOptionSlideContainer = new listOptionSlideContainer_1.default(filters, defaultFilters);
        _this.listOptionSlideContainer.observationProvider.observe(function () {
            _this.myNotesSwitchField.setValue(_this.listOptionSlideContainer.appliedFiltersModel.myNotes);
            _this.eventSearchField.setValue(_this.listOptionSlideContainer.appliedFiltersModel.eventId);
            _this._table.load();
        }, listOptionSlideContainerActions_1.default.OptionsApplied);
        _this._table.load();
        _this.loadEventOptions();
        return _this;
    }
    Object.defineProperty(AllMeetingsPage.prototype, "table", {
        get: function () {
            return this._table;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AllMeetingsPage.prototype, "meetingDetailForm", {
        get: function () {
            return this._meetingDetailForm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AllMeetingsPage.prototype, "isApp", {
        get: function () {
            return this.currentUserManager.clientChecker.isMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    return AllMeetingsPage;
}(bases_1.BasePage));
exports.default = AllMeetingsPage;
